import { Component, OnInit } from '@angular/core';
import { ReportCurrencyFormatter } from 'src/app/models/reportCurrencyFormatter';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { SalesOrderService } from 'src/app/services/sales-order.service';
import DateUtils from 'src/app/utils/date';

@Component({
  selector: 'app-margin-report',
  templateUrl: './margin-report.component.html',
  styleUrls: ['./margin-report.component.css']
})
export class MarginReportComponent implements OnInit {
  id;
  type;
  all;
  part;
  datas;
  payload;
  showGraph = false;
  selectedIds = null;
  selectedType = null;
  selectedPeriod = 'monthly'
  dateUtil = new DateUtils;
  selectedYr = new Date().getFullYear();
  public chartOptions = {
    series: [
      {
        name: "Margin",
        data: []
      },

    ],
    chart: {
      type: "bar",
      height: 300
    },
    plotOptions: {
      bar: {
        horizontal: false,
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      title: {
        text: 'Months',
      },
    },
    yaxis: {
      title: {
        text: 'Margin',
      },
      labels: {
        formatter: function (value) {
          const currencyF = new ReportCurrencyFormatter();
          return currencyF.handleFormatter(value)
        }
      },
    },
    colors: [
      "#00c851",
      // "#DC3545",
    ]
  };

  constructor(
    private salesOrdSrv: SalesOrderService,
    private performRepSrv: PerformanceReportService,
  ) {
    this.performRepSrv.selected_users.subscribe(res => {
      if (res && res.type) {
        const { ids, type } = res;
        this.selectedIds = ids;
        this.selectedType = type;
        this.handleDateFilter()
      }
    })
  }

  ngOnInit() {
    this.handleDateFilter();
  }

  handleDateFilter() {
    this.showGraph = false;
    this.getId();
    this.getMargin();
  }

  dateChange({ selectedPeriod, selectedYr }) {
    this.selectedYr = selectedYr;
    this.selectedPeriod = selectedPeriod;
    this.handleDateFilter();
  }

  getId() {
    this.resetGraph();
    let teamId;
    let creatorId;
    if (this.selectedType === "salesperson") {
      creatorId = this.selectedIds ? this.selectedIds.map(i => i.toString()) : null;
    } else {
      teamId = this.selectedIds ? this.selectedIds.map(i => i.toString()) : null;
    }
    let type = this.selectedType === "salesperson" ? 3 : this.selectedType === "team" ? 2 : null;
    this.payload = {
      startDate: this.selectedYr,
      teamID: teamId,
      salesPersonIDs: creatorId,
      type: type || 3,
    };
  }

  getMargin() {
    this.resetGraph();
    this.salesOrdSrv.getMarginStats(this.payload).subscribe((data: any) => {
      const margin = data.map(i => i.total);
      const totalmargin = margin.reduce((a, b) => Number(a) + Number(b));
      if (totalmargin == 0) {
        this.datas = [];
        this.showGraph = true;
      } else {
        this.datas = data;
        this.singleDataValue(margin);
      }
    })
  }

  singleDataValue(margin) {
    if (this.selectedPeriod === 'quaterly') {
      const quatersLabel = ['Q1', 'Q2', 'Q3', 'Q4'];
      const quarters = { 1: 0, 2: 0, 3: 0, 4: 0 };
      margin.forEach((m, i) => {
        const q = this.dateUtil.getQuarter(i);
        let count = quarters[q];
        if (count || count === 0) {
          count = Number(m) + count
        }
        quarters[q] = count;
      });
      const result = [];
      Object.values(quarters).forEach(q => result.push(q))
      this.chartOptions.xaxis.title.text = "Quaters";
      this.chartOptions.xaxis.categories = quatersLabel;
      this.chartOptions.series[0].data = result;
    } else {
      this.chartOptions.series[0].data = margin;
      this.chartOptions.xaxis.categories = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
        this.chartOptions.xaxis.title.text = "Months";
    }
    this.showGraph = true;
  }

  resetGraph() {
    this.showGraph = false;
  }

}
